import React from "react";
import { Container, Spinner } from "react-bootstrap";

const LoadingPage = () => {
    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <Container className="text-center">
                <Spinner animation="border" variant="primary" />
                <p className="text-muted mt-3 mb-0">Loading...</p>
            </Container>
        </div>
    );
};

export default LoadingPage;
